import he from 'he';

export const unescapeNotesHtml = (note: string | undefined): string => {
  if (!note) return '';
  return he.decode(note);
};
// it adds spaces between &lt; chars (<) and text to prevent being incorrectly removed
// by react-quill library thinking it is html
export const addSpaces = (note: string) => note.replaceAll(/((&lt;)+)([^ ])/g, '$1 $3');

export const isBlank = (note: any) =>
  !note ||
  note === '<p><br></p>' ||
  note === '<p></p>' ||
  note === '<h1></h1>' ||
  note === '<h2></h2>' ||
  note === '<h3></h3>' ||
  note.length === 0
    ? 1
    : 0;

export const stripHTMLTags = (html: string) => {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return doc?.body?.textContent?.trim();
};
